import EffectCtr from "../effect_yxx_ctr";

const { ccclass, property } = cc._decorator;
export enum EffectName {
    Ready, //准备摇得动画
    Result, //开奖结果
    SelfWin, //赢得结果
    SelfLose, //输得结果
    HeGuan, //荷官
    HeGuanFeiWen,//荷管飞吻
    FeiWen, //飞吻
    Wen, //吻
    StartBet,//开始下注
    EndBet, //结束下注
    NaoZhong,//闹钟
    ResultNum,  //开奖数字
}

@ccclass
export default class EffectCpCtr extends EffectCtr {

    @property(cc.Animation)
    resultNum: cc.Animation = null

    @property(dragonBones.ArmatureDisplay)
    startBetDragBones: dragonBones.ArmatureDisplay = null

    @property(dragonBones.ArmatureDisplay)
    endBetDragBones: dragonBones.ArmatureDisplay = null

    @property(dragonBones.ArmatureDisplay)
    resultDragBones: dragonBones.ArmatureDisplay = null

    playEffectAnim(playType:EffectName, callBack:Function = null, isHide:boolean = false, time:number = 0, loopTimes: number = -1){
        let animList = []
        let currentAnimation = null
        let cName = null
        switch(playType){
            case EffectName.Ready:
                currentAnimation = this.yaogu
                cName = "anim_caipiao_guan"
                break;
            case EffectName.Result:
                currentAnimation = this.kaijiang
                cName = "anim_caipiao_kai"
                break;
            case EffectName.SelfWin:
                currentAnimation = this.win
                animList.push({obj: this.resultDragBones, clipName: 'Win'})
                break;
            case EffectName.SelfLose:
                currentAnimation = this.lose
                animList.push({obj: this.resultDragBones, clipName: 'Lose'})
                break;
            case EffectName.HeGuanFeiWen:
                cName = "anim_yxx_heguan_feiwen"
                currentAnimation = this.heguan
            case EffectName.FeiWen:
                currentAnimation = this.feiwen
                break;
            case EffectName.Wen:
                currentAnimation = this.wen
                break;
            case EffectName.StartBet:
                currentAnimation = this.startBetDragBones
                cName = 'kaishixiazhu'
                break
            case EffectName.EndBet:
                currentAnimation = this.endBetDragBones
                cName = 'kaixiang'
                break;
            case EffectName.NaoZhong:
                currentAnimation = this.naoZhong 
                break;
            case EffectName.ResultNum:
                currentAnimation = this.resultNum 
                break;
            default:
                break;
        }


        if (currentAnimation != null ){
            currentAnimation.targetOff && currentAnimation.targetOff(this)
            currentAnimation.on("stop", ()=> {                    
                if (callBack != null) { 
                    if (time > 0){
                        this.scheduleOnce(()=>{
                            callBack()
                            currentAnimation.node.active = isHide
                        }, time)
                    }
                    else{
                        callBack()
                        currentAnimation.node.active = isHide
                    }
                } 
            }, this)
            currentAnimation.node.active = true
            if(currentAnimation instanceof dragonBones.ArmatureDisplay){                
                currentAnimation.playAnimation(cName, loopTimes)
            }else{
                currentAnimation.play(cName)
            }
            for (let index = 0; index < animList.length; index++) {
                const element = animList[index];
                if(element.obj instanceof dragonBones.ArmatureDisplay){
                    
                    element.obj.playAnimation(element.clipName, loopTimes)
                }else{
                    element.obj.play(element.clipName)
                }
            }
        }
    }


    
}